export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20overhead%20composition%20of%20carefully%20arranged%20fashion%20lifestyle%20elements%20including%20a%20pair%20of%20woven%20leather%20sandals%20a%20folded%20linen%20scarf%20and%20minimalist%20ceramic%20accessories%20on%20a%20textured%20cream%20linen%20fabric%20surface%20with%20soft%20golden%20hour%20sunlight%20streaming%20diagonally%20creating%20long%20gentle%20shadows%20editorial%20product%20photography%20with%20harmonious%20sandy%20beige%20and%20warm%20ivory%20tones%20no%20text%20no%20people%20sophisticated%20natural%20aesthetic&width=1800&height=900&seq=kakobuy-hero-v3-2026&orientation=landscape"
          alt="Best Kakobuy Spreadsheet - Verified Products and Trusted Sellers"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight">
            Best Kakobuy <br className="md:hidden" />
            <span className="italic font-semibold">Spreadsheet 2026</span>
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover the latest <strong>Kakobuy Spreadsheet</strong> with verified products,
            trusted sellers, faster shipping, and real quality checks. Updated daily for
            sneakers, clothing, accessories, and designer items.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 text-sm font-semibold bg-white text-foreground-950 rounded-md hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Kakobuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now &rarr;
            </a>
          </div>

          {/* Trust Strip */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-14 text-white/80 text-xs md:text-sm">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-accent-500"></i> Updated Daily
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-accent-500"></i> 10,000+ Products
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-accent-500"></i> Trusted Sellers
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-accent-500"></i> QC Photo Support
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line text-accent-500"></i> Worldwide Shipping
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}